/*
 * Windows Server Licensing Calculator
 *
 * Logic runs on stable IDs (question IDs and answer IDs), never on display text.
 * Display text comes from window.WS_CALC_I18N, which is rendered from the theme
 * locale files by snippets/ws-calc-i18n.liquid, so translation apps can translate it.
 *
 * Text that goes to the sales team (Express Quote form results, Calendly prefill)
 * always uses WS_CALC_EN below, so sales receives English regardless of storefront language.
 */

// English text used for sales-facing output, and as a fallback for display text
var WS_CALC_EN = {
  questions: {
    environment: 'Is this for an On-Premises or Cloud Environment?',
    lb_on_prem: 'Is your On-Premises environment either load balanced or failover?',
    lb_cloud: 'Is your Cloud environment either load balanced or failover?',
    version: 'What Version Year of Windows Server are you looking for?',
    host_specs: 'Enter your host specs:',
    vm_specs_legacy: 'Enter your VM specs:',
    same_cores: 'Do all your hosts have the same amount of cores?',
    cores_per_host: 'How many cores per host?',
    unique_hosts: 'How many unique hosts do you have?',
    unique_host_cores: 'Enter the amount of cores for each unique host:',
    vms_total: 'How many VMs do you need total?',
    hypervisor: 'What Hypervisor are you using?',
    vm_specs: 'Enter your VM(s) specs:',
    cores_per_vm: 'How many cores are allocated per VM?',
    vms_per_host: 'How many VMs are required per host?',
    dir_on_prem: 'Is your On-Premises environment set up with an Active Directory or a Workgroup?',
    dir_cloud: 'Is your Cloud environment set up with an Active Directory or a Workgroup?',
    ad_users_devices: 'How many named users or authenticating devices are in your Active Directory? (Min. 1 required)',
    ad_rds: 'Of your Named Users or Authenticating Devices, how many need the Remote Desktop Services (also known as RDP or Terminal Server)?',
    wg_devices: 'How many authenticating devices in your workgroup? (Only device CAL applicable in workgroup mode - Min. 1 required)',
    wg_rds: 'Of your authenticating Devices, how many need the Remote Desktop Services (also known as RDP or Terminal Server)?'
  },
  answers: {
    on_prem: 'On-Premises',
    cloud: 'Cloud',
    yes: 'Yes',
    no: 'No',
    not_sure: 'Not Sure',
    hyper_v: 'Hyper-V',
    vsphere: 'vSphere, Virtualbox, etc.',
    none: 'None',
    active_directory: 'Active Directory',
    workgroup: 'Workgroup',
    one_to_eleven: '1 to 11',
    twelve_plus: '12 or more'
  },
  ui: {
    continue: 'CONTINUE',
    not_sure_button: 'NOT SURE',
    enter_answer: 'Enter answer here',
    min_required: 'Minimum of [n] required',
    percent_complete: '[percent] COMPLETE',
    host: 'Host',
    vm: 'VM'
  },
  table: {
    physical_host: 'Physical Host',
    vm: 'VM',
    num_cores: '# of Cores',
    num_vms: '# of VMs',
    tip_cores: 'Number of physical cores across all CPUs in the server',
    tip_vms: 'Number of Virtual Machines running Windows Server',
    add_host: 'Add Host',
    add_row: 'Add Row',
    host_core_error: 'Each host requires an even number of cores greater than 1',
    vm_core_error: 'Each VM requires an even number of cores greater than 1',
    vm_count_error: '# of VMs per host must be 0 or higher',
    duplicate_row: 'Duplicate row',
    delete_row: 'Delete row',
    type: 'Type',
    num_users_devices: '# of Users/Devices',
    users: 'Users',
    devices: 'Devices'
  },
  responses: {
    hosts: '[label](s)',
    num_cores: '# Cores',
    num_vms: '# VMs',
    users: 'Users',
    devices: 'Devices'
  },
  results: {
    host: 'Host',
    vm: 'VM',
    num_cores: '# of Cores',
    num_vms: '# of VMs',
    recommended_license: 'Recommended License',
    num_licenses: '# of Licenses',
    cal_standard: 'Standard',
    cal_rds: 'RDS',
    cal_type_user: 'User',
    cal_type_device: 'Device',
    devices: 'Devices',
    core_disclaimer_vm: 'Microsoft requires a minimum of 16 cores licensed per VM',
    core_disclaimer_host: 'Microsoft requires a minimum of 16 cores licensed per host'
  },
  rfq: {
    title: 'WINDOWS SERVER CALC. RESULTS',
    server_licensing: 'Server Licensing:',
    host_line: 'Host #[n]: [cores] cores - [vms] vms - Rec. [license] - [count] Lic.',
    vm_line: 'VM #[n]: [cores] cores - Rec. [license] - [count] Lic.',
    vm_line_all: 'VM #1 - [cores] cores - Rec. [license] - [count] Lic.',
    cal_licensing: 'CAL Licensing:',
    license_line: 'License: [license] - Total: [total]',
    responses: 'RESPONSES:',
    host_spec_line: 'Host [name]: [cores] cores [vms] vms'
  },
  licenses: {
    host: 'Microsoft Windows Server [year] [edition] - [cores] Core License',
    vm: 'Microsoft Windows Server [edition] - 2 Core License[sa]',
    cal: 'Microsoft Windows Server [year] - 1 [type] Client Access License (CAL)',
    rds_cal: 'Microsoft Windows Server [year] - 1 RDS [type] Client Access License (CAL)[sa]',
    sa_suffix: ' (w/ Software Assurance)',
    type_user: 'User',
    type_device: 'Device'
  }
};

// Display text for the current storefront language (falls back to English per key)
var WS_CALC_I18N = window.WS_CALC_I18N || {};

function wsLookup(obj, path) {
  return path.split('.').reduce(function(o, k) { return (o && o[k] !== undefined) ? o[k] : undefined; }, obj);
}

// Replace [placeholders] in a string with values
function wsFmt(str, vars) {
  if (!vars) { return str; }
  return str.replace(/\[(\w+)\]/g, function(match, key) {
    return Object.prototype.hasOwnProperty.call(vars, key) ? String(vars[key]) : match;
  });
}

// Display text (translated)
function wsTr(path, vars) {
  var value = wsLookup(WS_CALC_I18N, path);
  if (value === undefined || value === null || value === '') { value = wsLookup(WS_CALC_EN, path); }
  if (value === undefined || value === null) { value = ''; }
  return wsFmt(String(value), vars);
}

// Sales-facing text (always English)
function wsEn(path, vars) {
  var value = wsLookup(WS_CALC_EN, path);
  return wsFmt(value === undefined ? '' : String(value), vars);
}

// Labels for IDs (version years have no label and show as-is)
function wsAnswerLabel(id) {
  return wsLookup(WS_CALC_EN, 'answers.' + id) !== undefined ? wsTr('answers.' + id) : id;
}
function wsAnswerLabelEn(id) {
  return wsLookup(WS_CALC_EN, 'answers.' + id) !== undefined ? wsEn('answers.' + id) : id;
}
function wsQuestionText(id) {
  return wsLookup(WS_CALC_EN, 'questions.' + id) !== undefined ? wsTr('questions.' + id) : id;
}
function wsQuestionTextEn(id) {
  return wsLookup(WS_CALC_EN, 'questions.' + id) !== undefined ? wsEn('questions.' + id) : id;
}

// Store user's answers to questions (indexes are used by the licensing logic below)
// Button answers are stored as the answer ID wrapped in single quotes, e.g. "'on_prem'"
var userAnswers = [
  { id: 'environment', answer: '' },            // 0
  { id: 'lb_on_prem', answer: '' },             // 1
  { id: 'lb_cloud', answer: '' },               // 2
  { id: 'version', answer: '' },                // 3
  { id: 'host_specs', objectArr: [] },          // 4
  { id: 'vm_specs_legacy', objectArr: [] },     // 5
  { id: 'same_cores', answer: '' },             // 6
  { id: 'cores_per_host', answerArr: [] },      // 7
  { id: 'unique_hosts', answer: '' },           // 8
  { id: 'unique_host_cores', answerArr: [] },   // 9
  { id: 'vms_total', answerArr: [] },           // 10
  { id: 'hypervisor', answerArr: [] },          // 11
  { id: 'vm_specs', objectArr: [] },            // 12
  { id: 'cores_per_vm', answerArr: [] },        // 13
  { id: 'dir_on_prem', answer: '' },            // 14
  { id: 'dir_cloud', answer: '' },              // 15
  { id: 'ad_users_devices', objectArr: [] },    // 16
  { id: 'ad_rds', objectArr: [] },              // 17
  { id: 'wg_devices', answer: '' },             // 18
  { id: 'wg_rds', answer: '' }                  // 19
];

// Store all calculator questions
var questionTree = [
  {
    id: 'environment',
    answers: ['on_prem', 'cloud'],
    followUpQuestions: { on_prem: 'lb_on_prem', cloud: 'lb_cloud' },
    percentComplete: '0%'
  },
  {
    id: 'lb_on_prem',
    answers: ['no', 'yes'],
    followUpQuestions: { yes: 'version', no: 'version' },
    percentComplete: '12%'
  },
  {
    id: 'lb_cloud',
    answers: ['no', 'yes'],
    followUpQuestions: { yes: 'vm_specs', no: 'vm_specs' },
    percentComplete: '20%'
  },
  {
    id: 'version',
    answers: ['2025', '2022', '2019', '2016', 'not_sure'],
    followUpQuestions: { '2025': 'host_specs', '2022': 'host_specs', '2019': 'host_specs', '2016': 'host_specs', not_sure: 'host_specs' },
    percentComplete: '25%'
  },
  {
    id: 'host_specs',
    inputLabel: 'host',
    answers: ['on-premises-table'],
    followUpQuestions: { 'on-premises-table': 'hypervisor' },
    percentComplete: '37%'
  },
  // The next seven questions are not reachable in the current flow; kept for reference
  {
    id: 'same_cores',
    answers: ['yes', 'no'],
    followUpQuestions: { yes: 'cores_per_host', no: 'unique_hosts' },
    percentComplete: '45%'
  },
  {
    id: 'unique_hosts',
    answers: ['standard-input'],
    followUpQuestions: { 'standard-input': 'unique_host_cores' },
    percentComplete: '52%'
  },
  {
    id: 'unique_host_cores',
    dependentQuestion: 'unique_hosts',
    answers: ['standard-input'],
    followUpQuestions: { 'standard-input': 'vms_total' },
    percentComplete: '63%'
  },
  {
    id: 'vms_total',
    answers: ['one_to_eleven', 'twelve_plus'],
    followUpQuestions: { one_to_eleven: 'dir_on_prem', twelve_plus: 'hypervisor' },
    percentComplete: '69%'
  },
  {
    id: 'hypervisor',
    answers: ['hyper_v', 'vsphere', 'none'],
    followUpQuestions: { hyper_v: 'dir_on_prem', vsphere: 'dir_on_prem', none: 'dir_on_prem' },
    percentComplete: '50%'
  },
  {
    id: 'cores_per_host',
    inputLabel: 'host',
    answers: ['standard-input'],
    followUpQuestions: { 'standard-input': 'vms_total' },
    percentComplete: '50%'
  },
  {
    id: 'vms_per_host',
    dependentQuestion: 'host_specs',
    inputLabel: 'host',
    answers: ['standard-input'],
    followUpQuestions: { 'standard-input': 'dir_on_prem' },
    percentComplete: '50%'
  },
  {
    id: 'vm_specs',
    inputLabel: 'vm',
    answers: ['cloud-table'],
    followUpQuestions: { 'cloud-table': 'dir_cloud' },
    percentComplete: '40%'
  },
  {
    id: 'cores_per_vm',
    dependentQuestion: 'vm_specs',
    inputLabel: 'vm',
    answers: ['standard-input'],
    followUpQuestions: { 'standard-input': 'dir_cloud' },
    percentComplete: '75%'
  },
  {
    id: 'dir_on_prem',
    answers: ['active_directory', 'workgroup', 'not_sure'],
    followUpQuestions: { active_directory: 'ad_users_devices', workgroup: 'wg_devices', not_sure: 'ad_users_devices' },
    percentComplete: '62%'
  },
  {
    id: 'dir_cloud',
    answers: ['active_directory', 'workgroup', 'not_sure'],
    followUpQuestions: { active_directory: 'ad_rds', workgroup: 'wg_rds', not_sure: 'ad_rds' },
    percentComplete: '60%'
  },
  {
    id: 'ad_users_devices',
    answers: ['user-device-table'],
    followUpQuestions: { 'user-device-table': 'ad_rds' },
    minimumInput: '1',
    percentComplete: '75%'
  },
  {
    id: 'ad_rds',
    answers: ['user-device-table-rds'],
    followUpQuestions: { 'user-device-table-rds': 'END' },
    minimumInput: '5',
    emptyInputAccepted: true,
    percentComplete: '80%'
  },
  {
    id: 'wg_devices',
    answers: ['standard-input'],
    followUpQuestions: { 'standard-input': 'wg_rds' },
    minimumInput: '1',
    percentComplete: '75%'
  },
  {
    id: 'wg_rds',
    answers: ['standard-input'],
    followUpQuestions: { 'standard-input': 'END' },
    emptyInputAccepted: true,
    percentComplete: '80%'
  },
  {
    id: 'END',
    answers: [],
    followUpQuestions: {},
    percentComplete: '100%'
  }
];

// The question currently on screen
var currentWsQuestionId = 'environment';

// Track the user's pathway to navigate backwards if needed
var previousQuestionPath = [];

// Default Calendly link
var calendlyWSLink = 'https://calendly.com/trusted-tech-team-licensing-engineer-uk/windows-server';

// Text sent to the 'Request a Quote' form.
// calcResults is always English (for sales). calcResultsLocal is the same text in the visitor's language.
// On non-English storefronts the form receives the local version followed by the English copy (see rfqForForm).
var calcResults = 'WINDOWS SERVER CALC. RESULTS\r\nServer Licensing:\r\n';
var calcResultsLocal = wsTr('rfq.title') + '\r\n' + wsTr('rfq.server_licensing') + '\r\n';

function getWsQuestion(id) {
  return questionTree.find(function(obj) { return obj.id == id; });
}

function getWsUserAnswer(id) {
  return userAnswers.find(function(obj) { return obj.id == id; });
}

// Answer ID stored for a button question ("'on_prem'" -> 'on_prem')
function storedAnswerId(answer) {
  return answer.includes("'") ? answer.split("'")[1] : answer;
}

// Show a question's text and answers
function renderWsQuestion(id) {
  currentWsQuestionId = id;
  document.getElementById('ws-question-text').innerHTML = wsQuestionText(id);
  displayAnswers(getWsQuestion(id));
}

// Markup for one row of the on-premises (host) table
function hostTableRowHTML(rowNumber, vmIconTooltip) {
  var html = '<tr class="on-premises-table-row" style="border-bottom: 1px solid darkgrey;"><td>#' + rowNumber + '</td><td><div style="transition: none; position: relative; border-radius: 5px; border: solid 1px var(--main-text-color);"><i class="fa-solid fa-circle-exclamation" data-tippy-content="' + wsTr('table.host_core_error') + '" style="display: none; position: absolute; right: 10px; top: 27%; color: red;"></i><input placeholder="' + wsTr('table.num_cores') + '" data-kind="cores" oninput="validateValue(this.value, this)" value="" class="table-input"><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 10px; top: 27%; color: var(--ttt-green);"></i></div></td>';
  html += '<td><div style="transition: none; position: relative; border-radius: 5px; border: solid 1px var(--main-text-color);"><i class="fa-solid fa-circle-exclamation"' + (vmIconTooltip ? ' data-tippy-content="' + wsTr('table.host_core_error') + '"' : '') + ' style="display: none; position: absolute; right: 10px; top: 27%; color: red;"></i><input placeholder="' + wsTr('table.num_vms') + '" data-kind="vms" oninput="validateValue(this.value, this)" value="" class="table-input"><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 10px; top: 27%; color: var(--ttt-green);"></i></div></td><td style="display: flex; justify-content: space-evenly;"><i class="fa-solid fa-copy" data-tippy-content="' + wsTr('table.duplicate_row') + '" onclick="duplicateTableRow(this,' + "'host'" + ')"></i><i class="fa-solid fa-trash-can" data-tippy-content="' + wsTr('table.delete_row') + '" onclick="deleteTableRow(this,' + "'host'" + ')"></i></td></tr>';
  return html;
}

// Markup for one row of the cloud (VM) table
function vmTableRowHTML(rowNumber) {
  return '<tr class="cloud-table-row" style="border-bottom: 1px solid darkgrey;"><td>#' + rowNumber + '</td><td><div style="transition: none; position: relative; border-radius: 5px; border: solid 1px var(--main-text-color);"><i class="fa-solid fa-circle-exclamation" data-tippy-content="' + wsTr('table.vm_core_error') + '" style="display: none; position: absolute; right: 10px; top: 27%; color: red;"></i><input placeholder="' + wsTr('table.num_cores') + '" data-kind="cores" oninput="validateValue(this.value, this)" value="" class="table-input"><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 10px; top: 27%; color: var(--ttt-green);"></i></div></td><td style="display: flex; justify-content: space-evenly;"><i class="fa-solid fa-copy" data-tippy-content="' + wsTr('table.duplicate_row') + '" onclick="duplicateTableRow(this,' + "'host'" + ')"></i><i class="fa-solid fa-trash-can" data-tippy-content="' + wsTr('table.delete_row') + '" onclick="deleteTableRow(this,' + "'vm'" + ')"></i></td></tr>';
}

// Markup for one row of the users/devices tables
function userDeviceRowHTML(rowClass, label) {
  return '<tr class="' + rowClass + '" style="border-bottom: 1px solid darkgrey;"><td>' + label + '</td><td><div style="transition: none; position: relative; border-radius: 5px; border: solid 1px var(--main-text-color);"><i class="fa-solid fa-circle-exclamation" style="display: none; position: absolute; right: 10px; top: 27%; color: red;"></i><input oninput="validateValue(this.value, this)" value="" class="table-input"><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 10px; top: 27%; color: var(--ttt-green);"></i></div></td></tr>';
}

// Display the answers or table for a question
function displayAnswers(questionObject) {
  if (userAnswers[3].answer == "'not_sure'") {
    userAnswers[3].answer = '2025';
  }

  if (userAnswers[15].answer == "'workgroup'" && userAnswers[19].answer == '') {
    userAnswers[19].answer = '0';
  }

  // Store the HTML for the possible answers that will be displayed for each question
  var questionInputsHTML = '';
  var minRequiredText = questionObject.minimumInput ? wsTr('ui.min_required', { n: parseInt(questionObject.minimumInput) }) : '';

  // Get all the possible answers for the current question and iterate through them all
  questionObject.answers.forEach((answer, index, arr) => {
    if(answer != undefined && answer != 'standard-input' && answer != 'on-premises-table' && answer != 'cloud-table' && answer != 'user-device-table' && answer != 'user-device-table-rds'){
      questionInputsHTML += '<button class="raise collection-button calc-button w-auto m-0" onclick="showNextWsQuestion(\'' + answer + '\')">' + wsAnswerLabel(answer) + '</button>';
      if (arr.length - 1 == index) {
        questionInputsHTML = '<div class="d-flex flex-wrap" style="gap: 10px;">' + questionInputsHTML + '</div>';
      }
    } else if (answer == 'standard-input') {
      if (questionObject.dependentQuestion){
        var dependentQuestion = getWsUserAnswer(questionObject.dependentQuestion);
        for(var i = 0; i<dependentQuestion.answer; i++ ){
          questionInputsHTML += '<div><p class="mb-0 mt-1"'+ wsTr('ui.' + questionObject.inputLabel) + ' #' + (i+1) + '</p><input id="standard-input-'+ i +'" data-toggle="collapse" data-target="#epSubNew" class="standard-input raise collection-button text-center" type="text" placeholder="' + wsTr('ui.enter_answer') + '"/></div>';
        }
        questionInputsHTML = '<div class="d-flex">' + questionInputsHTML + '</div><button class="raise collection-button calc-button btn-standard-submit" onclick="showNextWsQuestion('+"'"+answer+"'"+')">' + wsTr('ui.continue') + '</button>';
      } else {
        questionInputsHTML += '<div class="position-relative"><i class="fa-solid fa-circle-exclamation" ' + (questionObject.minimumInput && ('data-tippy-content="' + minRequiredText + '"')) + ' style="display: none; position: absolute; right: 20px; top: 38%; color: red;"></i><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 20px; top: 38%; color: green;"></i><input id="standard-input"' + (questionObject.minimumInput ? (' min="' + parseInt(questionObject.minimumInput) + '"') : ' ') + (questionObject.emptyInputAccepted ? (' data-emptyinputaccepted="true" ') : ' ');
        questionInputsHTML += 'data-toggle="collapse" data-target="#epSubNew" oninput="validateValue(this.value, this)" type="text" style="transition: none; text-align: center;" placeholder="' + wsTr('ui.enter_answer') + '" /></div><p style="color: red; display: none;" id="min-input-error"><i class="fa-solid fa-circle-exclamation" style="margin-right: 5px;"></i>' + minRequiredText + '</p><button style="transition: transform 0.25s;" class="raise collection-button calc-button" onclick="showNextWsQuestion('+"'"+answer+"'"+')"';
        questionInputsHTML += (parseInt(questionObject.minimumInput) > 0 && 'disabled') + '>' + wsTr('ui.continue') + '</button>';
      }
    } else if (answer == 'on-premises-table') {
      questionInputsHTML += '<table id="on-premises-table"><thead><tr><td>' + wsTr('table.physical_host') + '</td><td>' + wsTr('table.num_cores') + ' <i data-tippy-content="' + wsTr('table.tip_cores') + '" class="fa-solid fa-circle-info"></i></td><td>' + wsTr('table.num_vms') + ' <i data-tippy-content="' + wsTr('table.tip_vms') + '" class="fa-solid fa-circle-info"></i></td><td><button class="btn btn-primary" onclick="addTableRow(' + "'host'" + ')"> ' + wsTr('table.add_host') + ' </button></td></tr></thead><tbody id="on-premises-table-body">' + hostTableRowHTML(1, false) + '</tbody></table>';
      questionInputsHTML += '<ul style="margin: 0 auto; text-align: left; list-style: none;"><li style="color: red; display: none;" id="on-premises-table_host-error"><p><i class="fa-solid fa-circle-exclamation" style="margin-right: 5px;"></i>' + wsTr('table.host_core_error') + '</p></li><li style="color: red; display: none;" id="on-premises-table_vm-error"><p><i class="fa-solid fa-circle-exclamation" style="margin-right: 5px;"></i>' + wsTr('table.vm_count_error') + '</p></li></ul>' + '<button class="raise collection-button calc-button btn-table-submit" onclick="showNextWsQuestion('+"'"+answer+"'"+')">' + wsTr('ui.continue') + '</button>';
    } else if (answer == 'cloud-table') {
      questionInputsHTML += '<table id="cloud-table"><thead><tr><td>' + wsTr('table.vm') + ' <i data-tippy-content="' + wsTr('table.tip_vms') + '" class="fa-solid fa-circle-info"></i> </td><td>' + wsTr('table.num_cores') + ' <i data-tippy-content="' + wsTr('table.tip_cores') + '" class="fa-solid fa-circle-info"></i></td><td><button class="btn btn-primary" onclick="addTableRow(' + "'vm'" + ')"> ' + wsTr('table.add_row') + ' </button></td></tr></thead><tbody id="cloud-table-body">' + vmTableRowHTML(1) + '</tbody></table><p id="cloud-table_core-error" style="color: red; display: none;"><i class="fa-solid fa-circle-exclamation" style="margin-right: 5px;"></i>' + wsTr('table.vm_core_error') + '</p><button class="raise collection-button calc-button btn-table-submit" onclick="showNextWsQuestion('+"'"+answer+"'"+')">' + wsTr('ui.continue') + '</button>';
    } else if (answer == 'user-device-table') {
      questionInputsHTML += '<table id="user-device-table"><thead><tr><td>' + wsTr('table.type') + '</td><td>' + wsTr('table.num_users_devices') + '</td><td></td></tr></thead><tbody id="user-device-table-body">' + userDeviceRowHTML('user-device-table-row', wsTr('table.users')) + userDeviceRowHTML('user-device-table-row', wsTr('table.devices'));
      questionInputsHTML += '<div class="d-flex flex-row order-2"><button class="raise collection-button calc-button btn-table-submit order-2" onclick="showNextWsQuestion('+"'"+answer+"'"+')">' + wsTr('ui.continue') + '</button><button id="standard-0" class="raise collection-button calc-button btn-table-submit order-2" onclick="showNextWsQuestion('+"'"+answer+"'"+')">' + wsTr('ui.not_sure_button') + '</button></div>';
    } else if (answer == 'user-device-table-rds') {
      questionInputsHTML += '<table id="user-device-table-rds"><thead><tr><td>' + wsTr('table.type') + '</td><td>' + wsTr('table.num_users_devices') + '</td><td></td></tr></thead><tbody id="user-device-table-rds-body">' + userDeviceRowHTML('user-device-table-rds-row', wsTr('table.users')) + userDeviceRowHTML('user-device-table-rds-row', wsTr('table.devices'));
      questionInputsHTML += '<div class="d-flex flex-row order-2"><button class="raise collection-button calc-button btn-table-submit" onclick="showNextWsQuestion('+"'"+answer+"'"+')">' + wsTr('ui.continue') + '</button><button id="rds-0" class="raise collection-button calc-button btn-table-submit" onclick="showNextWsQuestion('+"'"+answer+"'"+')">' + wsTr('ui.not_sure_button') + '</button></div>';
    }
  });

  // Display input requirements for the current question if applicable
  if (questionObject.inputRequirements) {
    var inputRequirementsHTML = '<ul class="text-start">';
    questionObject.inputRequirements.forEach((item) => {
      inputRequirementsHTML += '<li>' + item + '</li>';
    });
    inputRequirementsHTML += '</ul>';
    document.getElementById('input-requirements').innerHTML = inputRequirementsHTML;
  } else {
    document.getElementById('input-requirements').innerHTML = '';
  }

  // Display everything
  document.getElementById('ws-question-answers').innerHTML = questionInputsHTML;
  document.querySelector('.progress-bar').style = "width: " + questionObject.percentComplete + "; background-color: var(--border-color);";
  document.querySelector('#percent-complete').innerHTML = wsTr('ui.percent_complete', { percent: questionObject.percentComplete });
}

// Toggle the view of 'Your Answers'
function toggleYourAnswers(toggle) {
  if (toggle == 'show') {
    $('#your-answers').height('min-content');
    $('#your-answers-cover').hide();
  } else if (toggle == 'hide') {
    $('#your-answers').height('225px');
    $('#your-answers-cover').show();
  }
}

// Show the previous question when user navigates backwards
function showPreviousWsQuestion() {

  // Find the previous question and display it
  let currentQuestionObject = getWsQuestion(previousQuestionPath[previousQuestionPath.length - 1]);
  currentWsQuestionId = currentQuestionObject.id;
  document.getElementById('ws-question-text').innerHTML = wsQuestionText(currentQuestionObject.id);

  // Find the previous question in userAnswers and set to empty
  userAnswers.find(function(obj) {
    if(obj.id == currentQuestionObject.id){
      if(obj.answer){
        obj.answer = '';
      } else if (obj.answerArr){
        obj.answerArr = [];
      } else if (obj.objectArr){
        obj.objectArr = [];
      }
    }
  });

  displayAnswers(currentQuestionObject);
  previousQuestionPath.pop();

  // If first question then hide 'previous' button
  if (previousQuestionPath.length > 0){
    $('.btn-previous').show();
  } else {
    $('.btn-previous').hide();
  }

  setTooltips();
}

// Edition names are Microsoft product names and stay in English; lang: 'display' or 'en'
function editionLabel(edition, lang) {
  var t = lang == 'en' ? wsEn : wsTr;
  if (edition == 'standard') { return 'Standard'; }
  if (edition == 'datacenter') { return 'Datacenter'; }
  if (edition == 'datacenter_sa') { return 'Datacenter' + t('licenses.sa_suffix'); }
  return '';
}

// Calculate the server licensing for on-premises environments to be displayed on the results page
function calculateHostLicense(host) {
  let hostResults = {
    name: '',
    cores: '',
    vms: '',
    license: '',
    licenseEn: '',
    licensePerHost: '',
    totalCores: '',
    user: '',
    device: ''
  };
  hostResults.name = host.name;
  hostResults.cores = host.cores;
  hostResults.vms = host.vms;
  let licenseType = '';
  let licenseCount = '';
  if (userAnswers[11].answer == "'hyper_v'") {
    if (parseInt(host.vms) < 12) {
      licenseType = 'standard';
      licenseCount = ((parseInt(host.vms) % 2) == 1) ? ((parseInt(host.vms)+1)/2) : (parseInt(host.vms)/2);
    } else if (parseInt(host.vms) >= 12) {
      licenseType = 'datacenter';
      licenseCount = 1;
    }
  } else if (userAnswers[11].answer == "'vsphere'") {
    if (parseInt(host.vms) < 29) {
      licenseType = 'standard';
      licenseCount = ((parseInt(host.vms) % 2) == 1) ? ((parseInt(host.vms)+1)/2) : (parseInt(host.vms)/2);
    } else if (parseInt(host.vms) >= 29) {
      licenseType = 'datacenter';
      licenseCount = 1;
    }
  } else if (userAnswers[11].answer == "'none'") {
    if (parseInt(host.vms) < 29) {
      licenseType = 'standard';
      licenseCount = ((parseInt(host.vms) % 2) == 1) ? ((parseInt(host.vms)+1)/2) : (parseInt(host.vms)/2);
    } else if (parseInt(host.vms) >= 29) {
      licenseType = 'datacenter_sa';
      licenseCount = 1;
    }
  }
  let licenseCores = '';
  if (parseInt(host.cores) <= 16) {
    licenseCores = '16';
  } else if (parseInt(host.cores) > 16) {
    if (parseInt(host.cores) % 2 == 1) {
      licenseCores = parseInt(host.cores) + 1;
    } else {
      licenseCores = host.cores;
    }
  }
  var year = userAnswers[3].answer.replace(/[']+/g, '');
  hostResults.license = wsTr('licenses.host', { year: year, edition: editionLabel(licenseType, 'display'), cores: licenseCores });
  hostResults.licenseEn = wsEn('licenses.host', { year: year, edition: editionLabel(licenseType, 'en'), cores: licenseCores });
  hostResults.licensePerHost = licenseCount;
  if (hostResults.licensePerHost == 0) {
    hostResults.licensePerHost = 1
  };
  hostResults.totalCores = ((parseInt(host.cores) < 16) ? 16 : ((parseInt(host.cores) % 2 == 1) ? (parseInt(host.cores) + 1) : parseInt(host.cores))) * hostResults.licensePerHost;
  return hostResults;
};

// Calculate the server licensing for cloud environments to be displayed on the results page
function calculateVmLicense(coreCount, numVms) {
  let vmResults = {
    license: '',
    licenseEn: '',
    licensePerHost: '',
    totalCores: ''
  };
  var edition = (numVms > 28) ? 'Datacenter' : 'Standard';
  vmResults.license = wsTr('licenses.vm', { edition: edition, sa: wsTr('licenses.sa_suffix') });
  vmResults.licenseEn = wsEn('licenses.vm', { edition: edition, sa: wsEn('licenses.sa_suffix') });
  vmResults.licensePerHost = (coreCount <= 8) ? 4 : (coreCount % 2 == 0) ? (coreCount / 2) : ((coreCount + 1) / 2);
  vmResults.totalCores = ((parseInt(coreCount) < 16) ? '16' : ((parseInt(coreCount) % 2 == 1) ? (parseInt(coreCount) + 1) : parseInt(coreCount))) * vmResults.licensePerHost;
  return vmResults;
}

// Validate the inputs on submit
// (data-kind="cores" / "vms" replaces the old placeholder text checks, so placeholders can be translated)
function validateInputs(answer) {
  let noContinue = false;
  if (answer == "on-premises-table" || answer == "cloud-table" || answer == 'user-device-table'){
    let hostError = false;
    let vmError = false;
    document.querySelectorAll('.table-input').forEach((input) => {
      if (input.dataset.kind == 'cores'){
        if (input.value <= 0 || input.value == '' || input.value % 2 != 0) {
          input.parentElement.style.border = '1px solid red';
          input.previousElementSibling.style.display = 'inline';
          hostError = true;
          noContinue = true;
        }
      } else if (input.dataset.kind == 'vms' && input.value < 0) {

          input.parentElement.style.border = '1px solid red';
          input.previousElementSibling.style.display = 'inline';
          vmError = true;
          noContinue = true;
      } else if (input.dataset.kind == 'vms' && input.value == ''){
          input.value = 0;
          input.setAttribute('value', 0);
          input.nextElementSibling.style.display = 'inline';
          input.parentElement.style.border = '1px solid var(--ttt-green)';
      }
    });
    hostError ? $('#cloud-table_core-error').show() : $('#cloud-table_core-error').hide();
    hostError ? $('#on-premises-table_host-error').show() : $('#on-premises-table_host-error').hide();
    vmError ? $('#on-premises-table_vm-error').show() : $('#on-premises-table_vm-error').hide();
    if (noContinue){ return false; }
  } else if (answer == "standard-input") {
    let minInputError = false;
    let input = document.querySelector('#standard-input');
    if ((parseInt(input.min) > 0 && parseInt(input.value) < parseInt(input.min)) && (input.dataset.emptyinputaccepted == 'true' ? (parseInt(input.value) != '0' || parseInt(input.value) != '') : true )){
      input.style.border = '1px solid red';
      input.previousElementSibling.style.display = 'inline';
      minInputError = true;
      noContinue = true;
    } else if (parseInt(input.min) == 0 && input.value == '') {
      input.value = 0;
      input.setAttribute('value', 0);
    }
    minInputError ? $('#min-input-error').show() : $('#min-input-error').hide();
    if (noContinue){ return false; }
  }
}

// Store the user's submitted input
function setAnswer(answer) {
  var answeredQuestion = getWsUserAnswer(currentWsQuestionId);
  if(answer == 'standard-input') {
    if (answeredQuestion.answerArr){
      document.querySelectorAll(".standard-input").forEach((input) => {
        answeredQuestion.answerArr.push(input.value);
      });
    } else {
      answeredQuestion.answer = document.getElementById('standard-input').value;
    }
  } else if (answer == 'cloud-table') {
    document.querySelectorAll(".cloud-table-row").forEach((row) => {
      let rowObj = {
        name: '',
        cores: ''
      };
      rowObj.name = row.children[0].innerHTML;
      rowObj.cores = row.children[1].children[0].children[1].value;
      answeredQuestion.objectArr.push(rowObj);
    });
  } else if (answer == 'on-premises-table') {
    document.querySelectorAll(".on-premises-table-row").forEach((row) => {
      let rowObj = {
        name: '',
        cores: '',
        vms: ''
      };
      rowObj.name = row.children[0].innerHTML;
      rowObj.cores = row.children[1].children[0].children[1].value;
      rowObj.vms = row.children[2].children[0].children[1].value;
      answeredQuestion.objectArr.push(rowObj);
    });
  } else if (answer == 'user-device-table') {
    document.querySelectorAll(".user-device-table-row").forEach((row) => {
      let rowObj = {
        name: '',
        cals: ''
      }
      rowObj.name = row.children[0].innerHTML;
      rowObj.cals = row.children[1].children[0].children[1].value;
      answeredQuestion.objectArr.push(rowObj);
    });
  } else if (answer == 'user-device-table-rds') {
    document.querySelectorAll(".user-device-table-rds-row").forEach((row) => {
      let rowObj = {
        name: '',
        cals: ''
      }
      rowObj.name = row.children[0].innerHTML;
      rowObj.cals = row.children[1].children[0].children[1].value;
      answeredQuestion.objectArr.push(rowObj);
    })
  }
   else {
    answeredQuestion.answer = "'" + answer + "'";
  }
}

// Show the next question based on the user's input
function showNextWsQuestion(answer) {
  if (validateInputs(answer) == false) { return; }

  (answer == "on-premises-table" || answer == "cloud-table" || answer == "user-device-table" || answer == 'user-device-table-rds') && window.scroll(0,0);

  $('.current-question').hide();

  setAnswer(answer);

  var currentQuestionObject = getWsQuestion(currentWsQuestionId);

  previousQuestionPath.push(currentQuestionObject.id);

  if (previousQuestionPath.length > 0){
    $('.btn-previous').show();
  } else {
    $('.btn-previous').hide();
  }

  var nextQuestion = currentQuestionObject.followUpQuestions[answer];
  currentWsQuestionId = nextQuestion;
  document.getElementById('ws-question-text').innerHTML = wsQuestionText(nextQuestion);

  var nextQuestionObject = getWsQuestion(nextQuestion);
  if(nextQuestionObject.id == 'END'){
    showResults();
  }

  displayAnswers(nextQuestionObject);

  $('.current-question').show();

  setTooltips();
}

// Validate input value on-change
function validateValue(value, e) {
  var isCores = e.dataset && e.dataset.kind == 'cores';
  var isVms = e.dataset && e.dataset.kind == 'vms';
  if (/^\d+$/.test(value)){
    if (value.split('')[0] == '0') {
      e.value = 0;
      e.setAttribute("value", 0);
    }
    else if ((isCores || parseInt(e.min) > 0) && value == 0) {
      e.value = '';
      e.setAttribute("value", '');
      return;
    } else {
      e.setAttribute("value",value);
    }
    if (e.id == 'standard-input') {
      if (e.min){
        if ((parseInt(e.value) >= parseInt(e.min)) || ((e.dataset.emptyinputaccepted == 'true') ? (parseInt(e.value) == 0 || parseInt(e.value) == '') : false)){
          e.previousElementSibling.style.display = 'none';
          e.style.border = "2px solid var(--ttt-green)";
          $('.fa-circle-exclamation').hide();
          $('.fa-circle-check').show();
          $('.collection-button').prop("disabled", false);
        } else {
          e.style.border = "2px solid red";
          $('.fa-circle-check').hide();
          $('.fa-circle-exclamation').show();
          $('.collection-button').prop("disabled", true);
        }
      } else if (value != ''){
        e.previousElementSibling.style.display = 'none';
        e.style.border = "2px solid var(--ttt-green)";
        $('.fa-circle-exclamation').hide();
        $('.fa-circle-check').show();
        $('.collection-button').prop("disabled", false);
      } else {
        e.style.border = "2px solid var(--main-text-color)";
        $('.fa-circle-check').hide();
        $('.fa-circle-exclamation').hide();
        $('.collection-button').prop("disabled", true);
      }
    } else {
      if (isCores && (parseInt(value) % 2 == 1 || parseInt(value) < 2 || e.value < 2)) {
          e.parentElement.style.border = "1px solid red";
          e.nextElementSibling.style.display = 'none';
          e.previousElementSibling.style.display = 'inline';
      } else {
        if (isCores || isVms) {
          e.parentElement.style.border = "1px solid var(--ttt-green)"
          e.previousElementSibling.style.display = 'none';
          e.nextElementSibling.style.display = 'inline';
        } else {
          e.previousElementSibling.style.display = 'none';
          $('.fa-circle-exclamation').hide();
          $('.fa-circle-check').show();
          e.parentElement.style.border = "1px solid var(--main-text-color)";
        }
      }
    }
  } else {
    if (e.id == 'standard-input' && value == ''){
      e.style.border = "2px solid var(--main-text-color)";
      e.style.color = "var(--main-text-color)";
      $('.fa-circle-check').hide();
      $('.fa-circle-exclamation').hide();

      (parseInt(e.min) == 0) ? $('.collection-button').prop("disabled", false) : $('.collection-button').prop("disabled", true);
      return;
    }
    let inputString = convertToNumeric(value);
    e.value = inputString;
    e.setAttribute("value", inputString);
    if (isCores || isVms) {
      e.parentElement.style.border = "1px solid var(--main-text-color)";
      e.style.color = "var(--main-text-color)";
      e.previousElementSibling.style.display = 'none';
      e.nextElementSibling.style.display = 'none';
    }
    return;
  }
}

// Remove any non-numerical values from string
function convertToNumeric(str) {
  return str.replace(/[^0-9]/g, '');
}

function displayLoadingIcon(){
  $('#loading-screen').show();
  setTimeout(() => {
    $('#loading-screen').hide();
  }, 3000);
}

// Set question and answers to be displayed on the results page
function setResponses() {
  var visibleAnswers = '';
  userAnswers.forEach((question) => {
    var questionText = wsQuestionText(question.id);
    if(question.answer){
      if(question.answer != ''){
        visibleAnswers += '<p style="margin-bottom: 0; color: var(--main-text-color);">' + questionText + '</p>';
        var displayedAnswer;
        if (question.answer.includes("'")){
          displayedAnswer = wsAnswerLabel(question.answer.split("'")[1]);
        } else {
          displayedAnswer = question.answer;
        }
        visibleAnswers += '<p style="color: var(--ttt-green);">' + displayedAnswer + '</p>';
      }
    }
    if(question.answerArr){
      var questionObj = getWsQuestion(question.id);

      if(question.answerArr.length > 0){
        visibleAnswers += '<p style="margin-bottom: 0; color: var(--main-text-color);">' + questionText + '</p>';
        question.answerArr.forEach((answer, index) => {
          visibleAnswers += '<p style="color: darkgrey;">' + wsTr('ui.' + questionObj.inputLabel) + " #"+ (index+1) + ": <span style='color: var(--ttt-green);'>" + answer + '</span></p>';
        });
      }
    }
    if(question.objectArr){
      let questionObjArr = getWsQuestion(question.id);
      if(question.objectArr.length > 0 && question.id == 'host_specs'){
        visibleAnswers += '<p style="margin-bottom: 0; color: var(--main-text-color);">' + questionText + '</p>';

        visibleAnswers += '<table class="my-3" style="background: var(--body-background);"><thead><tr style="color: var(--main-text-color); border-bottom: 1px solid var(--hr-color); font-weight: bold;"><td style="padding: 1rem;">' + wsTr('responses.hosts', { label: wsTr('ui.' + questionObjArr.inputLabel) }) + '</td><td style="padding: 1rem;">' + wsTr('responses.num_cores') + '</td>' + (questionObjArr.inputLabel == 'host' ? '<td style="padding: 1rem;">' + wsTr('responses.num_vms') + '</td>' : '') + '</tr></thead><tbody>';
        question.objectArr.forEach((obj) => {
          visibleAnswers += '<tr><td class="text-center" style="color: var(--main-text-color); padding: 1rem;">' + obj.name + '</td><td class="text-center" style="color: var(--ttt-green); padding: 1rem;">' + obj.cores + '</td>' + (questionObjArr.inputLabel == 'host' ? ('<td  class="text-center" style="color: var(--ttt-green); padding: 1rem;">' + obj.vms + '</td>') : '') + '</tr>';
        });
        visibleAnswers += '</tbody></table>';
      } else if (question.objectArr.length > 0 && (question.id == 'ad_users_devices' || question.id == 'ad_rds')) {
        visibleAnswers += '<p style="margin-bottom: 0; color: var(--main-text-color);">' + questionText + '</p>';

        visibleAnswers += '<table class="my-3" style="background: var(--body-background);"><thead><tr style="color: var(--main-text-color); border-bottom: 1px solid var(--hr-color); font-weight: bold;"><td style="padding: 1rem;">' + wsTr('responses.users') + '</td><td style="padding: 1rem;">' + wsTr('responses.devices') + '</td>' + '</tr></thead><tbody><tr>';
        question.objectArr.forEach((obj) => {
          visibleAnswers += '<td class="text-center" style="color: var(--ttt-green); border-bottom: 1px solid var(--hr-color); padding: 1rem;">' + Number(obj.cals) + '</td>';
        });
        visibleAnswers += '</tr></tbody></table>';
      }
    }
  });
  document.getElementById("wsc-responses").innerHTML = visibleAnswers;
}

// Set server licensing info to be displayed on the results page
function setServerLicensing() {
  var totalCores = 0;
  var hostTableResultsHTML = '';
  var vmTableResultsHTML = '';

  if (userAnswers[0].answer == "'on_prem'") {
    userAnswers[4].objectArr.forEach((host, i) => {
      let uniqueHost = calculateHostLicense(host);
      let hostData = 'Host #' + (i+1) + ': ' + uniqueHost.cores + ' cores - ' + uniqueHost.vms + ' vms - Rec. ' + uniqueHost.licenseEn + ' - ' + uniqueHost.licensePerHost + ' Lic.\r\n';
      appendToFormData(hostData, wsTr('rfq.host_line', { n: i+1, cores: uniqueHost.cores, vms: uniqueHost.vms, license: uniqueHost.license, count: uniqueHost.licensePerHost }) + '\r\n');
      hostTableResultsHTML += '<tr class="results-table-row"><td>' + uniqueHost.name + '</td><td>' + uniqueHost.cores + '</td><td>' + uniqueHost.vms + '<td class="text-start color-highlight">' + uniqueHost.license + '</td><td class="color-highlight">' + uniqueHost.licensePerHost + '</td></tr>'
      totalCores += uniqueHost.totalCores;
    });
    document.querySelector('#cores-of-licensing').innerHTML = totalCores;
    document.querySelector('#ws-table-header').innerHTML = '<th>' + wsTr('results.host') + '</th><th>' + wsTr('results.num_cores') + '</th><th>' + wsTr('results.num_vms') + '</th><th style="text-align: left;">' + wsTr('results.recommended_license') + '</th><th>' + wsTr('results.num_licenses') + '</th>';
    document.querySelector("#ws-table-results").innerHTML = hostTableResultsHTML;
  } else if (userAnswers[0].answer == "'cloud'") {
    let numCoreArray = [];
    userAnswers[12].objectArr.forEach((vm) => {
      numCoreArray.push(vm.cores);
    });
    if (numCoreArray.length < 29){
      for (let i = 0; i < numCoreArray.length;) {
        let uniqueVmOne = calculateVmLicense(numCoreArray[i], numCoreArray.length);
        let vmData = 'VM #' + (i+1) + ': ' + numCoreArray[i] + ' cores - Rec. ' + uniqueVmOne.licenseEn + ' - ' + uniqueVmOne.licensePerHost + ' Lic.\r\n';
        appendToFormData(vmData, wsTr('rfq.vm_line', { n: i+1, cores: numCoreArray[i], license: uniqueVmOne.license, count: uniqueVmOne.licensePerHost }) + '\r\n');
        totalCores += uniqueVmOne.totalCores;
        vmTableResultsHTML += '<tr class="results-table-row"><td>#' + (i+1) + '</td><td>' + numCoreArray[i] + '</td><td class="text-start color-highlight">' + uniqueVmOne.license + '</td><td class="color-highlight">' + uniqueVmOne.licensePerHost + '</td></tr>';
        i+=1;
      }
    } else {
      let uniqueVmOne = calculateVmLicense(numCoreArray[0], numCoreArray.length);
      let vmData = 'VM #1 - ' + numCoreArray[0] + ' cores - Rec. ' + uniqueVmOne.licenseEn + ' - ' + uniqueVmOne.licensePerHost + ' Lic.\r\n';
      appendToFormData(vmData, wsTr('rfq.vm_line_all', { cores: numCoreArray[0], license: uniqueVmOne.license, count: uniqueVmOne.licensePerHost }) + '\r\n');
      totalCores = uniqueVmOne.totalCores;
      for (let i = 1; i < numCoreArray.length+1;) {
        if (i == 1){
          vmTableResultsHTML += '<tr"><td>#' + (i) + '</td><td>' + numCoreArray[i-1] + '</td><td class="text-start color-highlight" rowspan="' + numCoreArray.length + '">' + uniqueVmOne.license + '</td><td class="color-highlight" rowspan="' + numCoreArray.length + '">' + uniqueVmOne.licensePerHost + '</td></tr>';
        } else {
          vmTableResultsHTML += '<tr"><td>#' + (i) + '</td><td>' + numCoreArray[i-1] + '</td></tr>';
        }
        i+=1;
      }
    }
    document.querySelector('#cores-of-licensing').innerHTML = totalCores;
    document.querySelector('#ws-table-header').innerHTML = '<th>' + wsTr('results.vm') + '</th><th>' + wsTr('results.num_cores') + '</th><th style="text-align: left;">' + wsTr('results.recommended_license') + '</th><th>' + wsTr('results.num_licenses') + '</th>';
    document.querySelector('#ws-table-results').innerHTML = vmTableResultsHTML;
  }
}

// CAL license names; kind: 'cal' or 'rds_cal', type: 'user' or 'device'
function calLicenseName(lang, kind, type) {
  var t = lang == 'en' ? wsEn : wsTr;
  var isCloud = userAnswers[0].answer == "'cloud'";
  return t('licenses.' + kind, {
    year: userAnswers[3].answer.replace(/[']+/g, ''),
    type: t('licenses.type_' + type),
    sa: (kind == 'rds_cal' && isCloud) ? t('licenses.sa_suffix') : ''
  });
}

// One row in the CAL results table plus the matching line for the quote form
function addCalRow(rowsSoFar, rowClass, kind, type, displayCount, formCount) {
  var label = kind == 'rds_cal' ? wsTr('results.cal_rds') : wsTr('results.cal_standard');
  var html = '<tr' + rowClass + '><td>' + label + '</td><td class="color-highlight">' + calLicenseName('display', kind, type) + '</td><td class="text-center color-highlight">' + displayCount + '</td></tr>';
  appendToFormData('License: ' + calLicenseName('en', kind, type) + ' - Total: ' + formCount + '\r\n', wsTr('rfq.license_line', { license: calLicenseName('display', kind, type), total: formCount }) + '\r\n');
  return rowsSoFar + html;
}

// Set CAL licensing info to be displayed on the results page
function setCalLicensing() {
  var calLicensingTableHTML = '';
  var calTableVisible = true;

  appendToFormData('\r\nCAL Licensing:\r\n', '\r\n' + wsTr('rfq.cal_licensing') + '\r\n');
  // Active Directory path
  if(userAnswers[14].answer == "'active_directory'" || userAnswers[15].answer == "'active_directory'" || userAnswers[14].answer == "'not_sure'" || userAnswers[15].answer == "'not_sure'") {

    let numUserCals = userAnswers[16].objectArr.length > 0 ? Number(userAnswers[16].objectArr[0].cals) : '';
    let numDeviceCals = userAnswers [16].objectArr.length > 0 ? Number(userAnswers[16].objectArr[1].cals) : '';
    let numUserRdsCals = userAnswers[17].objectArr.length > 0 ? Number(userAnswers[17].objectArr[0].cals) : '';
    let numDeviceRdsCals = userAnswers[17].objectArr.length > 0 ? Number(userAnswers[17].objectArr[1].cals) : '';

    if (userAnswers[0].answer == "'cloud'" && (userAnswers[17].answer == '0' || userAnswers[19].answer == '0')) {
      document.querySelector('#cal-licensing-container').remove();
      calTableVisible = false;
    }
    if (numUserCals == 0 && numDeviceCals == 0 && numUserRdsCals == 0 && numDeviceRdsCals == 0) {
      document.querySelector('#cal-licensing-container').remove();
      calTableVisible = false;
    }
    document.querySelectorAll(".cal-type").forEach((calType) => {
      calType.innerHTML = wsTr('results.cal_type_user');
    });
    // Set standard CALs
    if (userAnswers[0].answer == "'on_prem'" && userAnswers[16].objectArr.length > 0) {

      numUserCals = userAnswers[16].objectArr[0].cals == '' ? 0 : Number(userAnswers[16].objectArr[0].cals);
      numDeviceCals = userAnswers[16].objectArr[1].cals == '' ? 0 : Number(userAnswers[16].objectArr[1].cals);

      if (numUserCals > numDeviceCals) {
        if (numDeviceCals != 0) {
          document.querySelector('#standard-cals').innerHTML = userAnswers[16].objectArr[1].name;
          calLicensingTableHTML = addCalRow(calLicensingTableHTML, ' class="results-table-row"', 'cal', 'device', userAnswers[16].objectArr[1].cals, Number(userAnswers[16].objectArr[1].cals));
        } else {
          document.querySelector('#standard-cals').innerHTML = userAnswers[16].objectArr[0].name;
          calLicensingTableHTML = addCalRow(calLicensingTableHTML, ' class="results-table-row"', 'cal', 'user', userAnswers[16].objectArr[0].cals, Number(userAnswers[16].objectArr[0].cals));
        }
      } else if (numUserCals < numDeviceCals) {
        if (numUserCals != 0) {
          document.querySelector('#standard-cals').innerHTML = userAnswers[16].objectArr[0].name;
          calLicensingTableHTML = addCalRow(calLicensingTableHTML, ' class="results-table-row"', 'cal', 'user', userAnswers[16].objectArr[0].cals, Number(userAnswers[16].objectArr[0].cals));
        } else {
          document.querySelector('#standard-cals').innerHTML = userAnswers[16].objectArr[1].name;
          calLicensingTableHTML = addCalRow(calLicensingTableHTML, ' class="results-table-row"', 'cal', 'device', userAnswers[16].objectArr[1].cals, Number(userAnswers[16].objectArr[1].cals));
        }
      } else if (numUserCals == numDeviceCals && (numUserCals != 0 || numDeviceCals != 0)) {
        document.querySelector('#standard-cals').innerHTML = userAnswers[16].objectArr[0].name;
        calLicensingTableHTML = addCalRow(calLicensingTableHTML, ' class="results-table-row"', 'cal', 'user', userAnswers[16].objectArr[0].cals, Number(userAnswers[16].objectArr[0].cals));
      }
    }
    // Set RDS CALs
    if ((userAnswers[0].answer == "'on_prem'" || userAnswers[0].answer == "'cloud'") && userAnswers[17].objectArr.length > 0 && (userAnswers[17].objectArr[0].cals != '' || userAnswers[17].objectArr[1].cals != '')) {
      numUserRdsCals = userAnswers[17].objectArr[0].cals == '' ? 0 : Number(userAnswers[17].objectArr[0].cals);
      numDeviceRdsCals = userAnswers[17].objectArr[1].cals == '' ? 0 : Number(userAnswers[17].objectArr[1].cals);
      var userRdsCount = (numUserRdsCals < 5 ? 5 : numUserRdsCals);
      var deviceRdsCount = (numDeviceRdsCals < 5 ? 5 : numDeviceRdsCals);

      if (numUserRdsCals > numDeviceRdsCals) {
        if (numDeviceRdsCals == 0) {
          document.querySelector('#remote-desktop-cals').innerHTML = userAnswers[17].objectArr[0].name;
          calLicensingTableHTML = addCalRow(calLicensingTableHTML, '', 'rds_cal', 'user', userRdsCount, userRdsCount);
        } else {
          document.querySelector('#remote-desktop-cals').innerHTML = userAnswers[17].objectArr[1].name;
          calLicensingTableHTML = addCalRow(calLicensingTableHTML, '', 'rds_cal', 'device', deviceRdsCount, deviceRdsCount);
        }
      } else if (numUserRdsCals < numDeviceRdsCals) {
        if (numUserRdsCals == 0) {
          document.querySelector('#remote-desktop-cals').innerHTML = userAnswers[17].objectArr[1].name;
          calLicensingTableHTML = addCalRow(calLicensingTableHTML, '', 'rds_cal', 'device', deviceRdsCount, deviceRdsCount);
        } else {
          document.querySelector('#remote-desktop-cals').innerHTML = userAnswers[17].objectArr[0].name;
          calLicensingTableHTML = addCalRow(calLicensingTableHTML, '', 'rds_cal', 'user', userRdsCount, userRdsCount);
        }
      } else if (numUserRdsCals == numDeviceRdsCals && (numUserRdsCals != 0 && numDeviceRdsCals != 0)) {
        document.querySelector('#remote-desktop-cals').innerHTML = userAnswers[17].objectArr[0].name;
        calLicensingTableHTML = addCalRow(calLicensingTableHTML, '', 'rds_cal', 'user', userRdsCount, userRdsCount);
      } else {
        document.querySelector('#remote-desktop-cals').closest('p').remove();
      }
    }
  // Workgroup path
  } else if (userAnswers[14].answer == "'workgroup'" || userAnswers[15].answer == "'workgroup'") {
      numDeviceCals = Number(userAnswers[18].answer);
      numDeviceRdsCals = Number(userAnswers[19].answer);

      if (userAnswers[0].answer == "'cloud'" && numDeviceRdsCals == 0) {
        document.querySelector('#cal-licensing-container').remove();
        calTableVisible = false;
      }
      document.querySelectorAll(".cal-type").forEach((calType) => {
        calType.innerHTML = wsTr('results.cal_type_device');
      });
      // Set Standard CALs
      if ((userAnswers[0].answer == "'on_prem'") && numDeviceCals > 0) {
        document.querySelector('#standard-cals').innerHTML = wsTr('results.devices');
        calLicensingTableHTML = addCalRow(calLicensingTableHTML, ' class="results-table-row"', 'cal', 'device', userAnswers[18].answer, userAnswers[18].answer);
      }
      // Set RDS CALs
      if ((userAnswers[0].answer == "'on_prem'" || userAnswers[0].answer == "'cloud'") && numDeviceRdsCals > 0) {
        document.querySelector('#remote-desktop-cals').innerHTML = wsTr('results.devices');
        var wgRdsCount = (numDeviceRdsCals < 5 ? 5 : numDeviceRdsCals);
        var rdsRow = '<tr class="results-table-row"><td>' + wsTr('results.cal_rds') + '</td><td class="color-highlight">' + calLicenseName('display', 'rds_cal', 'device') + '</td><td class=text-center color-highlight">' + wgRdsCount + '</td></tr>';
        calLicensingTableHTML += rdsRow;
        appendToFormData('License: ' + calLicenseName('en', 'rds_cal', 'device') + ' - Total: ' + wgRdsCount + '\r\n', wsTr('rfq.license_line', { license: calLicenseName('display', 'rds_cal', 'device'), total: wgRdsCount }) + '\r\n');
      }
  }
  calTableVisible && (document.querySelector('#cal-table-results').innerHTML = calLicensingTableHTML);
}

// Toggle visibility of disclaimers
function setDisclaimers() {
  if (userAnswers[0].answer == "'cloud'") {
    document.querySelector('#core-disclaimer').innerHTML = wsTr('results.core_disclaimer_vm');
  } else {
    document.querySelector('#core-disclaimer').innerHTML = wsTr('results.core_disclaimer_host');
  }
  if ((userAnswers[17].answer == '' || parseInt(userAnswers[17].answer) == 0) && (userAnswers[19].answer == '' || parseInt(userAnswers[19].answer) == 0) && (userAnswers[14].answer != "'not_sure'" && userAnswers[15].answer != "'not_sure'")) {
    document.querySelector('#rds-disclaimer').remove();
  }
  if (parseInt(userAnswers[16].answer) >= 5 || parseInt(userAnswers[17].answer) >= 5 || parseInt(userAnswers[18].answer) >= 5 || parseInt(userAnswers[19].answer) >= 5) {
    document.querySelector('#cal-recommend-bundle').style.display = 'flex';
  }
}

// Sets the user's answers to be sent if 'Request a Quote' form submitted (English)
function addResponsesToRFQ() {
  calcResults += '\r\nRESPONSES:\r\n';
  userAnswers.forEach((question) => {
    var questionTextEn = wsQuestionTextEn(question.id);
    if(question.answer){
      if(question.answer != ''){
        calcResults += questionTextEn + '\r\n';
        var displayedAnswer;
        if (question.answer.includes("'")){
          displayedAnswer = wsAnswerLabelEn(question.answer.split("'")[1]);
        } else {
          displayedAnswer = question.answer;
        }
        calcResults += displayedAnswer + '\r\n\r\n';
      }
    }
    if(question.answerArr){
      var questionObj = getWsQuestion(question.id);
      if(question.answerArr.length > 0){
        calcResults += questionTextEn + '\r\n';
        question.answerArr.forEach((answer, index) => {
          calcResults += (questionObj.inputLabel == "'Host'" ? "Host " : "VM") + " %23"+ (index+1) + ": " + answer + '\r\n';
        });
        calcResults += '\r\n';
      }
    }
    if(question.objectArr){
      let questionObjArr = getWsQuestion(question.id);
      if(question.objectArr.length > 0 && question.id == 'host_specs'){
        calcResults += questionTextEn + '\r\n';
        question.objectArr.forEach((obj) => {
          calcResults += (questionObjArr.inputLabel == 'host' ? 'Host ' : 'VM ') + obj.name + ': ' + obj.cores + ' cores ' + (questionObjArr.inputLabel == 'host' ? (obj.vms + ' vms' ): '') + '\r\n';
        });
        calcResults += '\r\n';
      }
    }
  });
  // Same responses in the visitor's language
  calcResultsLocal += '\r\n' + wsTr('rfq.responses') + '\r\n';
  userAnswers.forEach((question) => {
    var questionText = wsQuestionText(question.id);
    if (question.answer) {
      calcResultsLocal += questionText + '\r\n';
      calcResultsLocal += (question.answer.includes("'") ? wsAnswerLabel(question.answer.split("'")[1]) : question.answer) + '\r\n\r\n';
    }
    if (question.answerArr && question.answerArr.length > 0) {
      var questionObj = getWsQuestion(question.id);
      calcResultsLocal += questionText + '\r\n';
      question.answerArr.forEach((answer, index) => {
        calcResultsLocal += wsTr('ui.' + questionObj.inputLabel) + " %23" + (index+1) + ": " + answer + '\r\n';
      });
      calcResultsLocal += '\r\n';
    }
    if (question.objectArr && question.objectArr.length > 0 && question.id == 'host_specs') {
      calcResultsLocal += questionText + '\r\n';
      question.objectArr.forEach((obj) => {
        calcResultsLocal += wsTr('rfq.host_spec_line', { name: obj.name, cores: obj.cores, vms: obj.vms }) + '\r\n';
      });
      calcResultsLocal += '\r\n';
    }
  });
}

// Text passed to the quote form: English only on the English storefront,
// otherwise the visitor's language first, then the English copy for sales
function rfqForForm() {
  if (!window.WS_CALC_BILINGUAL) { return calcResults; }
  return calcResultsLocal;
}

// Generate link to pre-filled Calendly form based on data from calculator (English)
function setPrefilledCalendlyFormLink() {
  var calendlyParams = {
    A: '',
    B: '',
    C: '',
    D: '',
    E: '',
    F: '',
    G: '',
    H: '',
  };

  calendlyParams.A = userAnswers[0].answer == "'cloud'" ? 1 : 2;
  calendlyParams.B = userAnswers[1].answer == "'yes'" ? 1 : 2;
  if (userAnswers[0].answer == "'on_prem'") {
    var versionId = userAnswers[3].answer.split("'")[1];
    calendlyParams.C = versionId === undefined ? versionId : wsAnswerLabelEn(versionId);
  } else {
    calendlyParams.C = '';
  }
  var hostAndVmInput = '';
  if (userAnswers[4].objectArr.length > 0) {
    userAnswers[4].objectArr.forEach((host, index) => {
      hostAndVmInput += "Host%20%23" + (index+1) + ":%20" + host.cores + "%20Cores%20and%20" + host.vms + "%20VMs%0A";
    });
    calendlyParams.D = hostAndVmInput;
  } else {
    userAnswers[12].objectArr.forEach((vm, index) => {
      hostAndVmInput += "VM%20%23" + (index+1) + ":%20" + vm.cores + "%20Cores%0A";
    });
    calendlyParams.D = hostAndVmInput;
  }
  if (userAnswers[0].answer == "'on_prem'") {
    var hypervisorId = userAnswers[11].answer.split("'")[1];
    calendlyParams.E = hypervisorId === undefined ? hypervisorId : wsAnswerLabelEn(hypervisorId);
  } else {
    calendlyParams.E = '';
  }
  if (userAnswers[14].answer == "'active_directory'" || userAnswers[15].answer == "'active_directory'") {
    calendlyParams.F = 1;
    if (userAnswers[0].answer == "'cloud'") {
      calendlyParams.G = '';
      calendlyParams.H = userAnswers[17].answer;
    } else {
      calendlyParams.G = userAnswers[16].answer;
      calendlyParams.H = userAnswers[17].answer;
    }
  } else if (userAnswers[14].answer == "'workgroup'" || userAnswers[15].answer == "'workgroup'"){
    calendlyParams.F = 2;
    if (userAnswers[0].answer == "'cloud'") {
      calendlyParams.G = '';
      calendlyParams.H = userAnswers[19].answer;
    } else {
      calendlyParams.G = userAnswers[18].answer;
      calendlyParams.H = userAnswers[19].answer;
    }
  } else {
    calendlyParams.F = 3;
    calendlyParams.G = 0;
    calendlyParams.H = 0;
  }
  calendlyWSLink += '?a2=' + calendlyParams.A + '&a3=' + calendlyParams.B + '&a4=' + calendlyParams.C + '&a5=' + calendlyParams.D + '&a6=' + calendlyParams.E + '&a7=' + calendlyParams.F + '&a8=' + calendlyParams.G + '&a9=' + calendlyParams.H;
}

// Triggered when user reaches the last question in a pathway
function showResults() {
  $("#wsc-questions").addClass("hidden");
  window.scroll(0,0);

  displayLoadingIcon();

  setTimeout(() => {
    $('#loading-screen').hide();
    if (userAnswers[14].answer || userAnswers[15].answer){
      $("#wsc-results").removeClass("hidden");
    } else {
      $("#wsc-no-results").removeClass("hidden");
    }
  }, 1000);

  setResponses();
  setServerLicensing();
  setCalLicensing();
  setDisclaimers();
  addResponsesToRFQ();

  // AE (Account Engagement) Express Quote landing page. Results are passed via 'wsc_results'.
  // pageHandle variable pulled from windows-server-calculator.liquid
  // WS_CALC_QUOTE_FORM_URL is set per language in snippets/ws-calc-i18n.liquid (German form on /de once it exists)
  var quoteFormUrl = window.WS_CALC_QUOTE_FORM_URL || 'https://marketing.trustedtechteam.com/l/1073191/2026-07-13/44lw3b5';
  // The AE landing page rejects very long links, so if the bilingual text would make the link
  // longer than 7,000 characters, send the English text only (same as the English storefront)
  var rfqText = rfqForForm();
  var rfqSrc = quoteFormUrl + '?wsc_results=' + encodeURIComponent(rfqText) + '&wsc_page=' + pageHandle;
  if (rfqSrc.length > 7000 && rfqText !== calcResults) {
    rfqSrc = quoteFormUrl + '?wsc_results=' + encodeURIComponent(calcResults) + '&wsc_page=' + pageHandle;
  }
  $('#request-a-quote-form').html('<iframe frameborder="0" id="rfq-iframe" style="height:697px;width:99%;border:none;color-scheme:light;" src="' + rfqSrc + '"></iframe>');

  setPrefilledCalendlyFormLink();
}

// Adds to the 'Request a Quote' form data (English, and the visitor's language when given)
function appendToFormData(data, localData) {
  calcResults += data;
  calcResultsLocal += (localData === undefined ? data : localData);
}

// Shows the first question in the calculator. Triggered when user clicks 'Start' on landing page.
function beginCalculator() {
  $("#main-questions-container").addClass("hidden");
  $("#wsc-questions").removeClass("hidden");
  window.scroll(0,0);
}

// Refreshes to start page. Triggered when user clicks any 'Restart Calculator' button
function restartWsCalc() {
  location.reload();
  window.scroll(0,0);
}

// Adds a new row based on the current table
function addTableRow(table) {
  if(table == 'host'){
    let hostBody = document.querySelector('#on-premises-table-body').innerHTML;
    let numHostsCurrent = document.querySelector('#on-premises-table-body').childElementCount;
    hostBody += hostTableRowHTML(numHostsCurrent + 1, true);
    document.querySelector('#on-premises-table-body').innerHTML = hostBody;
  } else if (table == 'vm') {
    let vmBody = document.querySelector('#cloud-table-body').innerHTML;
    let numVMsCurrent = document.querySelector('#cloud-table-body').childElementCount;
    vmBody += vmTableRowHTML(numVMsCurrent + 1);
    document.querySelector('#cloud-table-body').innerHTML = vmBody;
  }
  setTooltips();
}

// Duplicates the selected row
function duplicateTableRow(e, table) {
  var currentRow = e.closest('tr');
  var clone = e.closest('tr').cloneNode(true);
  currentRow.after(clone);
  var nextRow = currentRow.nextElementSibling;
  while (nextRow) {
    nextRow.firstChild.innerHTML = "#" + nextRow.rowIndex;
    nextRow = nextRow.nextElementSibling;
  }
  setTooltips();
}

// Deletes the current row
function deleteTableRow(e, table) {
  if(table == 'host'){
    let numHostsCurrent = document.querySelector('#on-premises-table-body').childElementCount;
    var currentRow = e.closest('tr');
    if (numHostsCurrent > 1) {
      var nextRow = currentRow.nextElementSibling;
      currentRow.remove();
      while (nextRow) {
        nextRow.firstChild.innerHTML = "#" + nextRow.rowIndex;
        nextRow = nextRow.nextElementSibling;
      }
    }
  } else if (table == 'vm'){
    let numVMsCurrent = document.querySelector('#cloud-table-body').childElementCount;
    var currentRow = e.closest('tr');
    if (numVMsCurrent > 1) {
      var nextRow = currentRow.nextElementSibling;
      currentRow.remove();
      while (nextRow) {
        nextRow.firstChild.innerHTML = "#" + nextRow.rowIndex;
        nextRow = nextRow.nextElementSibling;
      }
    }
  }
  setTooltips();
}

function setTooltips() {
  $(function() {
    tippy('[data-tippy-content]');
  });
}

// Display Calendly pop-up form
function scheduleWSCalc() {
  Calendly.showPopupWidget(calendlyWSLink);
  return false;
}

// Render the first question on load
renderWsQuestion('environment');
